import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';

const IconText = ({ icon, text, className }) => (
  <div className={[styles.container, className].join(' ')}>
    <div className={styles.imgPlaceholder}>
      <img src={icon} alt={text} />
    </div>
    <span className={styles.text}>{text}</span>
  </div>
);

IconText.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  className: PropTypes.string,
};

IconText.defaultProps = {
  className: '',
};

export default IconText;
